import { createStyles } from '@mantine/core';
import {
	ENTITY_NODE_PADDING,
	ENTITY_NODE_WIDTH,
} from '../EntityNode/EntityNode.constants';
import { ENTITY_NODE_HEADER_HEIGHT } from '../EntityNodeHeader/EntityNodeHeader.constants';
import {
	ENTITY_CHILDREN_MAX_HEIGHT,
	ENTITY_CHILDREN_ROW_HEIGHT,
} from './EntityNodeChildren.constants';

interface EntityNodeChildrenStylesProps {
	highlighted?: boolean;
}

export const useStyles = createStyles(
	(theme, { highlighted }: EntityNodeChildrenStylesProps) => ({
		wrapper: {
			cursor: 'default',
			position: 'relative',
			width: ENTITY_NODE_WIDTH,
			height: '100%',
			padding: ENTITY_NODE_PADDING,
			borderTop: `1px solid ${theme.other.getColor('border/secondary/default')}`,
			gap: theme.spacing.xs,
		},
		control: {
			cursor: 'pointer',
			height: ENTITY_CHILDREN_ROW_HEIGHT,
			paddingLeft: theme.spacing.xs,
			paddingRight: theme.spacing.xs,
			borderRadius: theme.radius.sm,
			gap: theme.spacing['3xs'],
			'&:hover': {
				backgroundColor: theme.other.getColor('surface/secondary/hover'),
			},
			'&:active': {
				backgroundColor: theme.other.getColor('surface/secondary/active'),
			},
		},
		panel: {
			gap: 0,
			overflowY: 'auto',
			maxHeight: highlighted ? '100%' : ENTITY_CHILDREN_MAX_HEIGHT,
		},
		highlightedPanel: {
			gap: 0,
			maxHeight: '100%',
		},
		skeleton: {
			width: '100%',
			height: ENTITY_CHILDREN_ROW_HEIGHT,
			alignItems: 'center',
		},
		handle: {
			visibility: 'hidden',
			top: `${
				ENTITY_NODE_HEADER_HEIGHT +
				ENTITY_NODE_PADDING +
				ENTITY_CHILDREN_ROW_HEIGHT / 2
			}px !important`,
		},
	})
);
